<template>
  <div class="gfb-password-field">
    <text-input
      :placeholder="placeholder"
      :label="placeholder"
      :type="show ? 'text' : 'password'"
      :value="value"
      :hasError="hasError"
      :errMsg="errMsg"
      @input="$emit('input', $event)"
      @update:modelValue="$emit('update:modelValue', $event)"
    >
      <template #trailing>
        <span class="gfb-toggle-visibility" @click="show = !show">
          <PhEyeSlash v-if="show" :size="20" color="#343946" />
          <PhEye v-else :size="20" color="#343946" />
        </span>
      </template>
    </text-input>
  </div>
</template>

<script>
import { PhEye, PhEyeSlash } from "@phosphor-icons/vue"

export default {
  name: "gfb-password-input",
  components: { PhEye, PhEyeSlash },
  props: {
    placeholder: { type: String, default: "Password" },
    value: { type: String, default: "" },
    modelValue: { type: String, default: "" },
    hasError: { type: Boolean, default: false },
    errMsg: { type: String, default: "" },
  },
  emits: ["input", "update:modelValue"],
  data() {
    return {
      show: false,
    }
  },
}
</script>

<style scoped>
.gfb-toggle-visibility {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
}
</style>
